import React, { useEffect } from 'react';
import { Icon } from '../design/icons';

// Displays the head of the toast queue. Auto-dismisses after 5s or when the
// close button is clicked, calling onDismiss(id) so the caller can dequeue it.
export default function Toast({ queue = [], onDismiss }) {
  const head = queue[0] ?? null;

  useEffect(() => {
    if (!head) return;
    const t = setTimeout(() => onDismiss(head.id), 5000);
    return () => clearTimeout(t);
  }, [head?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!head) return null;

  const isError = head.type === 'error';
  const color = isError ? 'var(--neg)' : 'var(--pos)';

  return (
    <div
      role="status"
      aria-live="polite"
      className="card rise"
      style={{
        position: 'fixed', left: '50%', bottom: 24, transform: 'translateX(-50%)',
        zIndex: 1000, maxWidth: 'min(420px, calc(100vw - 32px))',
        padding: '12px 14px',
        borderColor: `color-mix(in srgb, ${color} 40%, var(--line))`,
        display: 'flex', alignItems: 'center', gap: 10,
      }}
    >
      <span className="iconwrap" style={{ width: 22, height: 22, borderRadius: 7, flexShrink: 0, background: `color-mix(in srgb, ${color} 15%, transparent)`, color }}>
        <Icon name={isError ? 'alert' : 'check'} size={13} sw={2.2} />
      </span>
      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)', flex: 1, minWidth: 0 }}>
        {head.message}
      </span>
      <button type="button" onClick={() => onDismiss(head.id)} aria-label="Dismiss" className="pressable iconwrap" style={{ width: 24, height: 24, color: 'var(--ink-3)' }}>
        <Icon name="plus" size={12} style={{ transform: 'rotate(45deg)' }} />
      </button>
    </div>
  );
}
